import { useEffect, useRef } from "react";

type Options = {
  delayMs: number;
  enabled: boolean;
};

export function useTimerTrigger(
  open: () => void,
  { delayMs, enabled }: Options,
) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!enabled) return;

    timerRef.current = setTimeout(() => {
      open();
    }, delayMs);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [delayMs, open, enabled]);
}
